export default {"src":"https://static.jusbr.com/web/docview/_next/static/media/email.66f71419.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};